<template>
  <div class="d-flex flex-column fill-height pa-4 pb-0" v-if="event">
    <v-row class="flex-grow-0">
      <v-col class="text-left">
        <v-menu v-model="sendEmailMenuShown"
                :close-on-content-click="false"
                offset-x
                min-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :disabled="selectedEnrollmentIds.length === 0"
                   v-bind="attrs"
                   v-on="on">
              <v-icon class="mr-4">fas fa-paper-plane</v-icon>
              {{ $t('admin_enrollment.send_email') }}
            </v-btn>
          </template>

          <v-container>
            <v-card :elevation="2" class="pa-4">
              <v-select :label="$t('admin_enrollment.select_template')"
                        :items="emailTemplateOptions"
                        v-model="selectedEmailTemplate"></v-select>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text
                       @click="sendEmailMenuShown = false">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn text
                       @click="sendEmail">
                  {{ $t('admin_enrollment.send') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-menu>
      </v-col>
      <v-col class="text-right">
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn color="success"
                   class="ml-4"
                   :disabled="selectedEnrollmentIds.length === 0"
                   @click="acceptEnrollments"
                   v-on="on"
                   v-bind="attrs">
              <v-icon>fas fa-check</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('admin_enrollment.accept') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn color="red"
                   :dark="selectedEnrollmentIds.length !== 0"
                   class="ml-4"
                   :disabled="selectedEnrollmentIds.length === 0"
                   @click="rejectEnrollments"
                   v-on="on"
                   v-bind="attrs">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('admin_enrollment.reject') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn class="ml-4"
                   @click="exportEnrollments"
                   v-on="on"
                   v-bind="attrs">
              <v-icon>fas fa-file-export</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('export') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <EnrollmentList :event-id="eventId"
                    :search="searchEnrollment"
                    :fee-tiers="event.fee_tiers"
                    :refresh-trigger.sync="enrollmentRefreshTrigger"
                    v-model="selectedEnrollmentIds"></EnrollmentList>
  </div>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import EnrollmentList from "@/components/event/enrollment/EnrollmentList";
import {DateTime} from "luxon";

export default {
  name: 'EventEnrollment',
  components: {EnrollmentList},
  props: {
    eventId: String,
  },

  setup(props, {root, emit}) {
    onMounted(() => {
      getEvent();
      getEmailTemplates();
    })

    const event = ref(null);
    const getEvent = function () {
      root.$callAPI('hkiarace/admin/event/', {id: props.eventId}, function (response) {
        event.value = {
          ...response.body.event,
          languages: JSON.parse(response.body.event.languages),
          from_time: response.body.event.from_time ? DateTime.fromFormat(response.body.event.from_time, 'HH:mm:ss').toFormat('HH:mm') : null,
          to_time: response.body.event.to_time ? DateTime.fromFormat(response.body.event.to_time, 'HH:mm:ss').toFormat('HH:mm') : null,
        };
      });
    };

    // Email Templates
    const emailTemplates = ref([]);
    const emailTemplateOptions = computed(() => {
      return emailTemplates.value.map((t) => {
        return {value: t.id, text: t.name}
      });
    })
    const getEmailTemplates = function () {
      root.$callAPI('event/email_template/', {
        event_id: props.eventId,
      }, function (response) {
        emailTemplates.value = response.body.templates;
      });
    }

    const enrollmentRefreshTrigger = ref(false);
    const searchEnrollment = ref('');
    const selectedEnrollmentIds = ref([]);


    const sendEmailMenuShown = ref(false);
    const selectedEmailTemplate = ref(null);
    const sendEmail = function () {
      if (confirm(root.$t('admin_notification_template.confirm_send_email'))) {
        root.$callAPI('hkiarace/admin/event/enrollment/send_email/', {
          enrollment_ids: selectedEnrollmentIds.value,
          template_id: selectedEmailTemplate.value,
        }, () => {
          enrollmentRefreshTrigger.value = true;
        })
      }
    };

    const acceptEnrollments = function () {
      root.$callAPI('event/enroll/accept/', {enrollment_ids: selectedEnrollmentIds.value}, () => {
        enrollmentRefreshTrigger.value = true;
      });
    };
    const rejectEnrollments = function () {
      root.$callAPI('event/enroll/reject/', {enrollment_ids: selectedEnrollmentIds.value}, () => {
        enrollmentRefreshTrigger.value = true;
      });
    };
    const exportEnrollments = function () {
      root.$downloadFile('hkiarace/admin/event/enrollment/export/', {
        event_id: props.eventId,
      }, 'enrollment.xlsx');
    };

    return {
      event,

      enrollmentRefreshTrigger,
      searchEnrollment,
      selectedEnrollmentIds,

      emailTemplateOptions,

      sendEmailMenuShown,
      selectedEmailTemplate,
      sendEmail,

      acceptEnrollments,
      rejectEnrollments,
      exportEnrollments,
    }
  }
}
</script>
